import React, { useState } from 'react';
import '../App.css';
import NavBar from '../components/navbar';
import Mail from '../images/message.png';

function Contact() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [question, setQuestion] = useState('');
  const [message, setMessage] = useState('');

  const apiBaseUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async () => {
    const payload = {
      firstName,
      lastName,
      email,
      question,
    };

    try {
      const response = await fetch(`${apiBaseUrl}/contact/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage('Message sent successfully!');
        setFirstName('');
        setLastName('');
        setEmail('');
        setQuestion('');
      } else {
        setMessage(`Error: ${data.error || 'Failed to send message'}`);
      }
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div className="homepage">
      <NavBar />
      <div className="contactuspage">
        <div className="contactustext"><b>Have some questions?</b></div>
        <div className="contactmainsection">
          <div className="contactimage">
            <img src={Mail} alt="mail" />
          </div>
          <div className="contactus">
            <input
              placeholder="First Name"
              className="basicinput"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <input
              placeholder="Last Name"
              className="basicinput"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <input
              placeholder="Whats your email?"
              className="basicinput"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <textarea
              placeholder="Your question..."
              className="longinput"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
            />
            <div className="consultbutton bottom" style={{ marginTop: '3%' }} onClick={handleSubmit}>
              Send Message
            </div>
            {message && <p>{message}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
